import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateDocumentInputSchema, UpdateDocumentInputSchema, DocumentResponseSchema, } from "@hourly/api/document";
// ===== ENDPOINTS =====
const createDocument = oc
    .route({
    method: "POST",
    path: "/documents",
    summary: "Create a document",
    tags: ["Documents"],
})
    .input(CreateDocumentInputSchema)
    .output(DocumentResponseSchema);
const getDocument = oc
    .route({
    method: "GET",
    path: "/documents/{id}",
    summary: "Get a document by ID",
    tags: ["Documents"],
})
    .input(z.object({ id: z.uuid() }))
    .output(DocumentResponseSchema);
const listDocuments = oc
    .route({
    method: "GET",
    path: "/documents",
    summary: "List documents",
    tags: ["Documents"],
})
    .input(z.object({
    folderId: z.uuid().nullable().optional(),
    jobRoleId: z.uuid().optional(),
    signatureRequired: z.coerce.boolean().optional(),
    includeExpired: z
        .enum(["true", "false"])
        .optional()
        .transform((val) => val !== "false"), // undefined or "true" => true, "false" => false
}))
    .output(z.array(DocumentResponseSchema));
const updateDocument = oc
    .route({
    method: "PATCH",
    path: "/documents/{id}",
    summary: "Update a document",
    tags: ["Documents"],
})
    .input(z.object({
    id: z.uuid(),
}).merge(UpdateDocumentInputSchema))
    .output(DocumentResponseSchema);
const deleteDocument = oc
    .route({
    method: "DELETE",
    path: "/documents/{id}",
    summary: "Delete a document",
    tags: ["Documents"],
})
    .input(z.object({ id: z.uuid() }))
    .output(z.object({ success: z.boolean() }));
// ===== CONTRACT =====
export const documentContract = {
    create: createDocument,
    get: getDocument,
    list: listDocuments,
    update: updateDocument,
    delete: deleteDocument,
};
//# sourceMappingURL=document.js.map